import React from "react";
import ReactDOM from "react-dom";
import "react-quill/dist/quill.snow.css";
import "./assets/css/main.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";

// Expose React globally for libraries like react-apexcharts that rely on window.React
if (typeof window !== "undefined") {
    window.React = React;
}

// Suppress benign ResizeObserver notifications from Ant Design / Webpack dev overlay
if (typeof window !== "undefined") {
    if (window.ResizeObserver) {
        const OriginalResizeObserver = window.ResizeObserver;
        window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
            constructor(callback) {
                super((entries, observer) => {
                    window.requestAnimationFrame(() => {
                        callback(entries, observer);
                    });
                });
            }
        };
    }

    const isResizeObserverError = (msg) => {
        return (
            typeof msg === "string" &&
            (msg.includes("ResizeObserver loop") ||
                msg.includes("ResizeObserver") ||
                msg.includes("undelivered notifications"))
        );
    };

    window.addEventListener(
        "error",
        (e) => {
            if (isResizeObserverError(e?.message) || isResizeObserverError(e?.error?.message)) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        },
        true
    );

    window.addEventListener(
        "unhandledrejection",
        (e) => {
            if (isResizeObserverError(e?.reason?.message) || isResizeObserverError(e?.reason)) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        },
        true
    );

    const prevOnError = window.onerror;
    window.onerror = (message, source, lineno, colno, error) => {
        if (isResizeObserverError(message) || isResizeObserverError(error?.message)) {
            return true;
        }
        if (prevOnError) return prevOnError(message, source, lineno, colno, error);
    };

    const origConsoleError = console.error;
    console.error = (...args) => {
        if (
            args.some((arg) =>
                isResizeObserverError(typeof arg === "object" ? arg?.message : arg)
            )
        ) {
            return;
        }
        origConsoleError.apply(console, args);
    };
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);
